import { useDateFormat } from '@vueuse/core'

export default function (date?: Date, locale: string) {
  const articleDateFormat = useDateFormat(date, 'MMMM D, YYYY', { locales: locale })
  const nowFormat = useDateFormat(useNow(), 'YYYY-MM-DD HH:mm:ss', { locales: locale })

  return {
    articleDateFormat,
    nowFormat
  }
}
